/* 
 * Show and hide a modal which is described by the data-js-trigger 
 */
(function($){
    // JS
    window.Modal = {

        // Toggle a modal
        //======================================================================
        modal: function() {
            $(document).on('click', '[data-js-trigger]', function(e) {
                e.preventDefault();
            
                var body = $('body'),
                    target = $(this).data('js-trigger'),
                    modal = $('[data-js-modal='+target+']'),
                    inner = modal.find('[data-css-modal=modal]'),
                    close = $('[data-js-close=close]'), 
                    lastFocusElement = $(':focus'),
                    video = $('.modal-video');

                    console.log(video);

                    video.trigger('play');


                $(this).addClass('test');
            
                // hide any currently open modals / prevents double modalling    
                hideModal($('[data-js-modal]'), body, video);
            
                // show the modal that we have targeted via the trigger
                modal.fadeIn('fast');
                inner.attr('tabindex', '0').focus();
                body.addClass('modal-open');
            
                // close on clicking X or on clicking anywhere outside of the modal
                (close, modal).on('click', function(e) {
                    if ((!$(e.target).closest(inner).length) || ($(e.target).closest(close).length)) {
                        hideModal(modal, body, video);
                        lastFocusElement.focus();
                    }
                });
            
                // close on pressing escape key
                body.keydown(function(e) {
                    if(!e.keyCode || e.keyCode == 27) {
                        hideModal(modal, body, video);
                        lastFocusElement.focus();
                    }
                });
            });
            
            var hideModal = function(modal, body, video) {
                modal.fadeOut('fast');
                body.removeClass('modal-open');
                video.trigger('pause');
            }
        }                         
    }
    // Run
    $(function(){
        Modal.modal();
    });


}(jQuery));
